import { fetchOnce } from "../../util/fetch";
import { Service } from "../../service/device/setup";
import { Show } from "solid-js"
import { Spinner, Card, Button, Row, Col } from "solid-bootstrap";

export function BackgroundPicker(props) {
    const theme = props.theme;
    const backgroundImages = props.backgroundImages;

    function isLoaded() {
        return !theme.loading && !backgroundImages.loading;
    }

    function onClickNoImage(e) {
        return Service.getTheme(theme().uuid).then(theme => {
            theme.image_fit = "none"
            theme.image_uuids = [];
            return Service.updateTheme(theme);
        });
    }

    function makeImageOnClickApplyHandler(bucketFile) {
        return (e) => {
            const backgroundImageUUID = bucketFile.metadata.link;
            if (!backgroundImageUUID) {
                throw new Error(`no link for thumbnail ${bucketFile.uuid}`);
            }
            Service.getTheme(theme().uuid).then(theme => {
                theme.image_fit = "cover"
                theme.image_uuids = [backgroundImageUUID];
                Service.updateTheme(theme);
            });
        };
    }

    function makeImageOnClickDeleteHandler(bucketFile) {
        return (e) => {
            const backgroundImageUUID = bucketFile.metadata.link;
            if (!backgroundImageUUID) {
                throw new Error(`no link for thumbnail ${bucketFile.uuid}`);
            }
            return Service.getTheme(theme().uuid).then(theme => {
                return Service.deleteBucketFile(backgroundImageUUID).then(() => {
                    return Service.deleteBucketFile(bucketFile.uuid).then(() => {
                        if (props.onDelete) {
                            props.onDelete();
                        }
                    });
                });
            });
        };
    }

    return <>
        <Show when={isLoaded()}>
            <Row g={3}>
                <Col sm="6" md="4" lg="3">
                    <Card style={{ width: '18rem' }}>
                        <Card.Body>
                            <Button variant="primary" onClick={onClickNoImage}>No image</Button>
                        </Card.Body>
                    </Card>
                </Col>
                <For each={backgroundImages()}>{(img, i) =>
                    <Col sm="6" md="4" lg="3">
                        <BackgroundOption bucketFile={img} onClickApply={makeImageOnClickApplyHandler(img)} onClickDelete={makeImageOnClickDeleteHandler(img)} />
                    </Col>
                }</For>
            </Row>
        </Show>
        <Show when={!isLoaded()}>
            <Spinner animation="border" />
        </Show>
    </>
}

function BackgroundOption(props) {
    const [imageURL, isURLLoaded, isURLError] = fetchOnce(() => Service.getBucketFileDownloadURL(props.bucketFile.uuid));
    function isUserTag(bucketFile) {
        return bucketFile.tag && bucketFile.tag === "user_background_image_thumb";
    }
    return <>
        <Show when={isURLLoaded()}>
            <Card>
                <Card.Img variant="top" src={imageURL()} style="max-width: 18rem"></Card.Img>
                <Card.Body>
                    <Button variant="primary" onClick={props.onClickApply}>Apply</Button>
                    <Show when={isUserTag(props.bucketFile)}>
                        <Button variant="danger" onClick={props.onClickDelete}>Delete</Button>
                    </Show>
                </Card.Body>
            </Card>
        </Show>
        <Show when={!isURLLoaded()}>
            <Spinner animation="border" />
        </Show>
    </>

}